import SvgIcon, { SvgIconProps } from "@mui/material/SvgIcon";

export default function MentalWellbeingIcon(props: SvgIconProps) {
  return (
    <SvgIcon viewBox="0 0 40 40" fill="none" {...props}>
      <path
        d="M40 22.7907C38.8372 32.3256 31.6393 40 20.4651 40C10.4651 40 0 33.9648 0 22.7907C0 2.09302 11.384 0 22.5581 0C33.7323 0 40 11.6166 40 22.7907Z"
        fill="#ECF4FC"
      />
      <path
        d="M14.9155 23.2529C17.2194 21.1409 20.8929 20.8571 23.6323 22.3506C26.286 23.7973 27.9941 26.7122 28.269 29.7402L28.2905 30.0342C23.0629 30.4989 17.94 30.3829 12.7554 29.5635C12.5363 29.5286 12.2921 29.479 12.1606 29.2979C12.054 29.1495 12.0506 28.9538 12.061 28.7715C12.127 27.6278 12.5821 26.5402 13.1499 25.5469C13.6309 24.7048 14.2022 23.9068 14.9155 23.2529ZM20.5718 10.8496C23.4711 10.8497 25.0972 13.892 25.0972 16.8184C24.7954 19.3153 22.928 21.3251 20.0288 21.3252C17.4341 21.3252 14.7184 19.7446 14.7183 16.8184C14.7183 11.3978 17.6724 10.8496 20.5718 10.8496Z"
        fill="#3167F5"
      />
      <path
        d="M18.939 17.6653C18.2899 16.9597 17.1886 15.8714 16.8418 16.9093C16.4881 17.9676 17.0873 18.4212 17.441 18.4212C18.1109 18.4212 18.939 16.9092 20.437 16.1532C21.9351 15.3972 23.4331 15.5484 23.2833 16.758C23.1335 17.9676 21.9351 17.9676 21.1861 17.9676C20.437 17.9676 19.688 15.4463 19.688 14.49C19.688 13.5828 19.2386 12.8269 18.4896 13.1293C17.7406 13.4317 16.8418 15.246 18.0402 15.5484C19.2386 15.8508 20.5293 13.9462 21.1861 13.5828C21.5814 13.3639 22.4803 13.2127 22.2347 14.49C21.988 15.7729 21.9351 18.4211 21.1861 18.7235C20.437 19.0259 19.7503 18.4213 18.939 17.6653Z"
        stroke="#ECF4FC"
        strokeWidth="0.653061"
      />
    </SvgIcon>
  );
}
